export type GateDecision = 'denied' | 'ready' | 'bootstrap';

export function decideGate(input: {
  email: string | null;
  accessExists: boolean;
  admins: string[];
  invited: boolean;
}): GateDecision {
  if (!input.email) return 'denied';
  if (!input.accessExists) return 'bootstrap';
  if (input.invited) return 'ready';
  if (input.admins.includes(input.email)) return 'bootstrap';
  return 'denied';
}
